import { render, staticRenderFns } from "./AdministrativeUnitsView.vue?vue&type=template&id=3d9a6d9b&"
import script from "./AdministrativeUnitsView.vue?vue&type=script&lang=js&"
export * from "./AdministrativeUnitsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports